import qs from 'qs';
import client from '@/api/base';
import clientCas from '@/api/baseOfCas';
import clientCoach from '@/api/baseOfCoach';

// Child
import invoice from './invoice';

export default {
  async uploadProfileImage(file) {
    const bodyFormData = new FormData();
    bodyFormData.append('profile_image', file);
    const response = await client.patch('account/coach/profile-image/', bodyFormData);
    return response;
  },

  // Coach's detail
  async getCoachList(params) {
    const response = await client.get(`coaching/coaches/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getCoachAvailableDay(uuid) {
    const response = await client.get(`coaching/coaches/${uuid}/schedules/days/`);
    return response;
  },

  async updateUserProfile(data) {
    const response = await client.patch('account/current-user/', data);
    return response;
  },

  async updateUserProfileToCas(data) {
    const response = await clientCas.patch('current-user/', data);
    return response;
  },

  async getCoachAlerts() {
    const response = await client.get('coaching/coach/status/');
    return response;
  },

  // Coach demographic
  async getCoachDemographic() {
    const response = await clientCoach.get('account/gcg-demographics/');
    return response;
  },

  async createCoachDemographic(data) {
    const response = await clientCoach.post('account/gcg-demographics/', data);
    return response;
  },

  async updateCoachDemographic(data) {
    const response = await clientCoach.patch('account/gcg-demographics/', data);
    return response;
  },

  async getLeaderInvitation(params) {
    const response = await client.get(`account/coach/leader-invite/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async inviteLeader(data) {
    const response = await client.post('account/coach/leader-invite/', data);
    return response;
  },

  async getInviteStatus() {
    const response = await client.get('account/coach/leader-invite/status/');
    return response;
  },

  async deleteLeaderInvitation(id) {
    const response = await client.delete(`account/coach/leader-invite/${id}/`);
    return response;
  },

  async bulkUpdateLeaderEngagement(data) {
    const response = await client.post('coaching/leader/bulk/engagement-status-update/', data);
    return response;
  },

  async getBulkLeaderEngagement() {
    const response = await client.get('coaching/leader/bulk/engagement-status-update/');
    return response;
  },

  async updateLeaderEngagement(uuid, data) {
    const response = await client.patch(`coaching/leader/${uuid}/status/`, data);
    return response;
  },

  ...invoice,
};
